import { render, staticRenderFns } from "./PrizeEditor.vue?vue&type=template&id=f67b66ee"
import script from "./PrizeEditor.vue?vue&type=script&lang=js"
export * from "./PrizeEditor.vue?vue&type=script&lang=js"
import style0 from "./PrizeEditor.vue?vue&type=style&index=0&id=f67b66ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports